import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, distinct, filter, map, mergeMap } from 'rxjs/operators';

import { CompanyManagerService } from '@shared/services/company-manager.service';

import { managerGet, managerLoadFailed, managerLoadSuccess } from './managers.action';

@Injectable()
export class ManagersEffects {

  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType(managerGet),
      distinct(({ id }) => id),
      mergeMap(({ id }) => this.companyManagerService.getCompanyManager(id)
        .pipe(
          filter((v) => !!v),
          map((manager) => managerLoadSuccess({ manager })),
          catchError((error) => of(managerLoadFailed({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private companyManagerService: CompanyManagerService,
  ) { }
}
